export default __webpack_public_path__ + "static/media/our_department.5d366c1f.jpg";